import { CoreInputViewNew, CoreLayoutView, CoreTextView, ORIENTATION_ENUM } from '@core/widgets';
import React, { useId } from 'react';
import { SemanticColor, semanticColorsV1 as semanticColors } from '../../../theme/colors';
import { TextStyle } from '../../../types/styles';
import styles from '../CalculatorV1.module.css';
import { getClearValue, getFormattedValue } from '../utils/format/format';
import { THandleUpdateValue } from '../utils/types';

type TCalculatorInputProps = {
    label?: string;
    name: string;
    value: string;
    isError?: boolean;
    isFrom?: boolean;
    handleUpdateValue: THandleUpdateValue;
    fontSize: string;
    subRow: React.ReactNode;
    tabIndex?: number;
    parentStyleNames?: string[];
    inputRef?: React.RefObject<HTMLInputElement | null>;
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
};

const CalculatorInputV1 = React.memo(
    ({ label, isError, value, handleUpdateValue, tabIndex, subRow, name, isFrom, fontSize, parentStyleNames, inputRef, onFocus }: TCalculatorInputProps) => {
        const inputId = useId();

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const clearValue = getClearValue(e?.target.value, value);
            handleUpdateValue(clearValue, e.target.name, isFrom);
        };
        return (
            <CoreLayoutView
                styleName="calculatorInputColumn"
                parentStyleNames={parentStyleNames}
                styleProps={{ orientation: ORIENTATION_ENUM.VERTICAL, lineX: 'center' }}
            >
                <CoreTextView
                    text={label}
                    styleName="calculatorInputTitle"
                    parentStyleNames={parentStyleNames}
                    styleProps={{
                        ...TextStyle.secondary,
                        main: semanticColors[SemanticColor.TextSecondary],
                        margin: { bottom: 4 },
                    }}
                />
                <div className={styles.calculatorInputWrapper}>
                    <CoreInputViewNew
                        styleName="calculatorInputAmount"
                        parentStyleNames={parentStyleNames}
                        styleProps={{
                            font: TextStyle.display1.font,
                            outline: 'transparent',
                            onSurface: semanticColors[SemanticColor.TextPrimary],
                            padding: { top: 0, right: 0, bottom: 0, left: 0 },
                            textAlign: 'center',
                            height: 48,
                            error: { main: semanticColors[SemanticColor.TextError], onSurface: semanticColors[SemanticColor.BorderError] },
                            fontStyle: { fontSize: parseInt(fontSize) || 40, fontSizeXl: 48, lineHeightXl: 64 },
                            hovered: {
                                onSurface: semanticColors[SemanticColor.FillPrimary],
                            },
                        }}
                        dataTest={`calculator_input_${isFrom ?? ''}`}
                        id={inputId}
                        name={name}
                        value={getFormattedValue(value)}
                        autoComplete="off"
                        onChange={handleChange}
                        type="text"
                        inputMode="decimal"
                        tabIndex={tabIndex}
                        isError={isError}
                        inputRef={inputRef}
                        onFocus={onFocus}
                    />
                </div>
                {subRow}
            </CoreLayoutView>
        );
    },
);
export { CalculatorInputV1 };
